import Cache from '@fs/zion-cache'
import type { Person, PID } from '@fs/zion-tree-types'
import { fetcher } from '../useSwrRequest'

const portraitUrl = (pid?: string): string => `/service/memories/tps/persons/${pid}/portrait`
const portraitCache = new Cache({ storeName: 'portrait_r9', encrypted: process.env.NODE_ENV === 'production' })

/**
 * Reads person from tree-data backend and adds portrait status.
 */
export async function readPerson(url: string, cache?: Cache): Promise<(Person & { id: PID }) | undefined> {
  // Extract PID from url
  const pid = /\/person\/(.*)\//.exec(url)?.[1]
  const personPr = fetcher<Person & { id: PID }>(url, cache)
  const portraitPr = fetcher<{ processingStateModel: string; screeningStateModel: string }>(
    portraitUrl(pid),
    portraitCache
  )
  // The portrait call may return a 404, so get and examine the result from all promises.
  const [personRes, portraitRes] = await Promise.allSettled([personPr, portraitPr])
  if (personRes.status === 'rejected') throw personRes.reason
  const person = personRes.value
  if (portraitRes.status === 'fulfilled') {
    const portrait = portraitRes.value
    if (person && portrait) {
      if (portrait.processingStateModel === 'FAILED') {
        person.portraitStatus = 'failed'
      } else if (portrait.processingStateModel !== 'PROCESSED') {
        person.portraitStatus = 'processing'
      } else if (portrait.screeningStateModel !== 'APPROVED') {
        person.portraitStatus = 'approving'
      } else if (person.portraitUrl) {
        person.portraitStatus = 'ready'
      }
    }
  } else if (person) {
    // If error, make sure portraitStatus is cleared
    delete person.portraitStatus
  }
  return person
}
